import MarkerClusterer from "@google/markerclusterer"
import GoogleMapReact from "google-map-react"
import { meters2ScreenPixels } from "google-map-react/lib/utils/utils"
import PropTypes from "prop-types"
import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"

import LocationIcon from "../../images/icons/location.png"
import SingleLgIcon from "../../images/map-cluster-icons/m0.png"
import ClusterIcon1 from "../../images/map-cluster-icons/m1.png"
import ClusterIcon2 from "../../images/map-cluster-icons/m2.png"
import ClusterIcon3 from "../../images/map-cluster-icons/m3.png"
import ClusterIcon4 from "../../images/map-cluster-icons/m4.png"

import * as actions from "./redux/actions"

// If geolocation is not possible, then initialize the map to show all of Switzerland
export const MAP_DEFAULT_CENTER = { lat: 46.7985286, lng: 8.2296008 }
export const MAP_DEFAULT_ZOOM = 8

const LocationMarker = ({ w, h }) => {
  const w2 = Math.max(16, Math.round(w / 2))
  const h2 = Math.max(16, Math.round(h / 2))
  w = 2 * w2
  h = 2 * h2

  return (
    <div className="location-marker" style={{ width: w, height: h, left: -w2, top: -h2 }}>
      <div className="inner" />
    </div>
  )
}
LocationMarker.propTypes = {
  lat: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  lng: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  w: PropTypes.number.isRequired,
  h: PropTypes.number.isRequired,
}

const createMapOptions = maps => ({
  mapTypeControl: true,
  mapTypeControlOptions: { position: maps.ControlPosition.TOP_RIGHT },
  mapTypeId: maps.MapTypeId.ROADMAP,
  zoomControl: true,
  zoomControlOptions: { position: maps.ControlPosition.RIGHT_BOTTOM },
})

export class PropertiesMap extends Component {
  static propTypes = {
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  }

  componentDidMount() {
    this.props.actions.updateCurrentLocation()
  }

  render() {
    const { updateMapProps, dismissUpdateCurrentLocationError } = this.props.actions
    const {
      mapCenter,
      location,
      accuracy,
      zoomLevel,
      updateCurrentLocationError,
      updateCurrentLocationInfo,
    } = this.props.home

    this.updateClusteredPropertyMarkers()

    return (
      <div className="google-map-container">
        <GoogleMapReact
          onGoogleApiLoaded={({ map, maps }) => {
            if (map && maps) {
              this.maps = maps

              this.addCurrentLocationCustomControl(map, maps)

              this.updateClusterer(map)
              this.updateClusteredPropertyMarkers()
            }
          }}
          yesIWantToUseGoogleMapApiInternals
          bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_MAPS_KEY }}
          center={mapCenter}
          zoom={zoomLevel}
          defaultCenter={MAP_DEFAULT_CENTER}
          defaultZoom={MAP_DEFAULT_ZOOM}
          options={createMapOptions}
          onChange={updateMapProps}
        >
          {location && accuracy && (
            <LocationMarker
              lat={location.lat}
              lng={location.lng}
              {...meters2ScreenPixels(accuracy, location, zoomLevel)}
            />
          )}
        </GoogleMapReact>

        {updateCurrentLocationError && (
          <div className="google-map-error" onClick={dismissUpdateCurrentLocationError}>
            {updateCurrentLocationError}
          </div>
        )}

        {updateCurrentLocationInfo && <div className="google-map-info">{updateCurrentLocationInfo}</div>}
      </div>
    )
  }

  addCurrentLocationCustomControl = (map, maps) => {
    const { updateCurrentLocation } = this.props.actions

    const wrapperDiv = document.createElement("div")
    wrapperDiv.setAttribute("id", "location-icon-wrapper")

    const controlUI = document.createElement("div")
    controlUI.setAttribute("id", "location-icon-container")
    wrapperDiv.appendChild(controlUI)

    const icon = document.createElement("img")
    icon.setAttribute("src", LocationIcon)
    controlUI.appendChild(icon)

    maps.event.addDomListener(controlUI, "click", function() {
      updateCurrentLocation()
    })

    map.controls[maps.ControlPosition.RIGHT_BOTTOM].push(wrapperDiv)
  }

  updateClusterer = map => {
    if (!this.clusterer) {
      this.clusterer = this.addClusterer(map)
    } else if (this.clusterer.getMap() !== map) {
      this.clusterer.clearMarkers()
      this.clusterer = this.addClusterer(map)
    }
  }

  addClusterer = map => {
    const clusterStyles = [
      {
        url: ClusterIcon1,
        height: 40,
        width: 40,
        anchor: [14, 18],
        textColor: "white",
        textSize: 10,
      },
      {
        url: ClusterIcon2,
        height: 60,
        width: 60,
        anchor: [24, 25],
        textColor: "white",
        textSize: 11,
      },
      {
        url: ClusterIcon3,
        height: 75,
        width: 75,
        anchor: [31, 28],
        textColor: "white",
        textSize: 12,
      },
      {
        url: ClusterIcon4,
        height: 90,
        width: 90,
        anchor: [38, 31],
        textColor: "white",
        textSize: 13,
      },
    ]

    return new MarkerClusterer(map, [], {
      averageCenter: true,
      gridSize: 36,
      minimumClusterSize: 2,
      styles: clusterStyles,
      zoomOnClick: true,
    })
  }

  updateClusteredPropertyMarkers = () => {
    if (this.clusterer && this.maps) {
      const { Size, Point, LatLng, Marker } = this.maps
      const { updateMapProps } = this.props.actions
      const { properties } = this.props.home.lhoData

      const singleMarkerIcon = {
        url: SingleLgIcon,
        size: new Size(20, 20),
        anchor: new Point(10, 10),
      }

      const onSingleMarkerClick = ({ latLng }) =>
        updateMapProps({ center: { lat: latLng.lat(), lng: latLng.lng() }, zoom_in: 3 })

      const propertyMarkers = properties
        .filter(property => Number(property.latitude) && Number(property.longitude))
        .sort((a, b) => a.latitude - b.latitude || a.longitude - b.longitude)
        .map(property => {
          const position = new LatLng(property.latitude, property.longitude)
          const title = `${property.reference} ${property.description}`
          const marker = new Marker({ icon: singleMarkerIcon, position, title })
          marker.addListener("click", onSingleMarkerClick)
          return marker
        })

      this.clusterer.clearMarkers()
      this.clusterer.addMarkers(propertyMarkers)
    }
  }
}

/* istanbul ignore next */
const mapStateToProps = state => ({ home: state.home })

/* istanbul ignore next */
const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PropertiesMap)



// WEBPACK FOOTER //
// ./src/features/home/PropertiesMap.js